module.exports = __webpack_public_path__ + "static/media/pmi_prep_1_small.1dee7be3.jpg";